import workloadsApi from "../../api/workloads";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

const state = {
  userWorkloads: [],
  workloadTypeDefinitions: [],
  approvedWorkloads: [],
  deniedWorkloads: [],
  pendingWorkloads: [],
  files: []
};

const getters = {
  getWorkloadById: state => workloadId => {
    return _.find(state.approvedWorkloads, function(workload) {
      return workload.workloadId == workloadId;
    });
  }
};

const actions = {
  getWorkloadTypeDefinitions(context) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .getWorkloadTypeDefinitions()
        .then(function(response) {
          context.commit("updateWorkloadTypeDefinitions", response.data);
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  getApprovedWorkloads(context, timePeriodId) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .getApprovedWorkloads(timePeriodId)
        .then(function(response) {
          context.commit("updateApprovedWorkloads", response.data);
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  getDeniedWorkloads(context, timePeriodId) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .getDeniedWorkloads(timePeriodId)
        .then(function(response) {
          context.commit("updateDeniedWorkloads", response.data);
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  getPendingWorkloads(context, timePeriodId) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .getPendingWorkloads(timePeriodId)
        .then(function(response) {
          context.commit("updatePendingWorkloads", response.data);
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  getAllWorkloadsByAsurite(context, asuriteId) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .getAllWorkloadsByAsurite(asuriteId)
        .then(function(response) {
          if (response.data) {
            context.commit("updateUserWorkloads", response.data);
          } else {
            context.commit("updateUserWorkloads", []);
          }
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  getApprovedWorkloadsByAsurite(context, asuriteId) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .getApprovedWorkloadsByAsurite(asuriteId)
        .then(function(response) {
          if (response.data) {
            context.commit("updateUserWorkloads", response.data);
          } else {
            context.commit("updateUserWorkloads", []);
          }
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  populateWorkloadById(context, workloadId) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .getWorkloadById(workloadId)
        .then(function(response) {
          context.commit("updateWorkload", response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  approveWorkload(context, [workloadId, notes]) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .approveWorkload(workloadId, notes)
        .then(function(response) {
          context.commit("addWorkloadStatus", response.data);
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  sendApprovalEmail(context, workloadId) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .createApproveWorkloadEmail(workloadId)
        .then(function(response) {
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  denyWorkload(context, [workloadId, notes]) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .denyWorkload(workloadId, notes)
        .then(function(response) {
          context.commit("addWorkloadStatus", response.data);
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  sendDenyEmail(context, workloadId) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .createDenyWorkloadEmail(workloadId)
        .then(function(response) {
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  addWorkloadFiles(context, workloadId) {
    var formData = new FormData();
    //formData.append("data", JSON.stringify(context.state.workload));

    _.forEach(context.state.files, function(file) {
      // add each file to the form data
      formData.append("files[]", file);
    });

    return new Promise((resolve, reject) => {
      workloadsApi
        .postWorkloadFiles(workloadId, formData)
        .then(function(response) {
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }
};

const mutations = {
  addWorkloadStatus(state, value) {
    var editingWorkload = _.find(state.approvedWorkloads, function(workload) {
      return workload.workloadId === value.workloadId;
    });
    editingWorkload.workloadStatuses.push(value);
  },

  updateUserWorkloads(state, value) {
    state.userWorkloads = value;
  },

  updateWorkloadTypeDefinitions(state, value) {
    state.workloadTypeDefinitions = value;
  },

  // update a single workload
  updateWorkload(state, value) {
    var index = _.findIndex(state.approvedWorkloads, function(workload) {
      return workload.workloadId === value.workloadId;
    });

    // add content to the array if it's new, update if not
    if (index > -1) {
      state.approvedWorkloads.splice(index, 1, value);
    } else {
      state.approvedWorkloads.push(value);
    }
  },

  // update entire list of workloads at once
  updateApprovedWorkloads(state, value) {
    state.approvedWorkloads = value;
  },

  updateDeniedWorkloads(state, value) {
    state.deniedWorkloads = value;
  },

  updatePendingWorkloads(state, value) {
    state.pendingWorkloads = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
